<template>
    <div id="main-layout-middle"
         :style="{ 'background-color': backgroundColor }"
    >
        <Snackbar />
        <UploadStatus />
        <AppOnboardingStepFreeLuts v-if="startTipsStep == 'free-luts-download'" />

        <div id="wrapper">
            <div id="content">
                <span class="image-before-label">Original</span>

                <div id="canvases">
                    <canvas id="dpx-canvas"></canvas>
                    <canvas id="tiff-export-canvas" class="hide"></canvas>
                    <canvas id="thumbnail-canvas"></canvas>
                    <canvas id="colour-match-canvas"></canvas>
                    <canvas id="develop-raw-canvas" class="hide"></canvas>
                </div>

                <VideoProgress />
                <VideoControls />
                <VideoTimestamp />
            </div>
        </div>

        <div id="main-layout-middle__bottom-area" class="hide">
            <IDTMenu />
            <ViewControls />
            <ODTMenu />
        </div>

        <Scopes />

        <div id="blocks-canvas-container" class="ui-widget-content" style="display: none">
            <select id="curveSelect">
                <option disabled selected value="default">Select curve</option>
            </select>
            <span id="reset-selected-canvases-btn">Reset</span>
        </div>

    </div>
</template>

<script>
import Snackbar from "@/components/app/ui/Snackbar";
import AppOnboardingStepFreeLuts from "@/components/app/ui/AppOnboardingStepFreeLuts";

import UploadStatus from "@/components/app/files/UploadStatus";

import VideoProgress from "@/components/app/files/VideoProgress";
import VideoControls from "@/components/app/files/VideoControls";
import VideoTimestamp from "@/components/app/files/VideoTimestamp";

import Scopes from "@/components/app/scopes/Scopes";

import IDTMenu from "@/components/app/ui/IDTMenu.vue";
import ODTMenu from "@/components/app/ui/ODTMenu.vue";
import ViewControls from "@/components/app/ui/ViewControls.vue";

import { mapGetters, mapState } from "vuex";

export default {
    name: "MainLayoutMiddle",
    components: {
        ViewControls,
        ODTMenu,
        IDTMenu,
        Snackbar,
        AppOnboardingStepFreeLuts,

        UploadStatus,

        VideoProgress,
        VideoControls,
        VideoTimestamp,

        Scopes,
    },

    computed: {
        ...mapState("File/Media", ["active"]),
        ...mapState("UI", ["backgroundColor", "startTipsStep"]),
    },
}
</script>

<style lang="scss" scoped>
#main-layout-middle {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr var(--tools-container-height);;
    grid-template-areas: "main" "controls";
    height: 100%;

    &.--scopes-view {
        grid-template-rows: var(--status-container-height) 1fr 242px var(--tools-container-height);
        grid-template-areas: "main" "main" "scopes" "scopes";
    }

    &__bottom-area {
        display: flex;
        justify-content: space-between;
        align-items: center;
        grid-area: controls;
        padding: 0 40px;
        position: relative;
        font-size: 1rem;

        ::v-deep .v-btn {
            min-width: auto;
            height: auto;
            box-shadow: none;
            background-color: transparent;
            color: var(--font-default-color);
            padding: 3px;
            text-transform: initial;
            letter-spacing: initial;

            &--active {
                &::before {
                    background-color: var(--color-accent);
                    opacity: 0.4;
                }
            }

            &--disabled,
            &--disabled .v-icon {
                background-color: transparent !important;
                color: var(--font-default-color) !important;
                opacity: 0.4;
            }

            i {
                font-size: 1.7rem;
            }
        }
    }

    .import-media-btn {
        display: inline-flex;
        grid-area: main;
        max-width: 200px;
        justify-self: center;
    }
}
</style>
